import { createStandardAction } from "typesafe-actions";
import { RepImage } from "../../models/User";

export const setRepImages =
  createStandardAction("SET_REP_IMAGES")<RepImage[]>();
